/**
 * @desc 申请释放保证金
 */
import { UnfreezeApplyForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateUnfreezeApplyParameter = UnfreezeApplyForm

const method = 'POST'
const url = '/trade/member/unfreezeApply'

export const createUnfreezeApplyApi = (
  data?: CreateUnfreezeApplyParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

createUnfreezeApplyApi.method = method
createUnfreezeApplyApi.url = url
